import { useState, useContext, useEffect } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { HiMenuAlt3 } from "react-icons/hi";
import { MdDarkMode, MdLightMode } from "react-icons/md";
import { IconButton } from '@mui/material';
import { useThemeMode } from '../context/theme/ThemeProvider';
import { TYPES } from '../../config/constants/typesReducers';
import AuthService from '../services/auth-service';

import logo_icon from '../../assets/webp/logo_complete.webp';
import logo_icon_white from '../../assets/webp/logo_complete_white.webp';
import user_icon from '../../assets/webp/avatar-male.webp';

import "../styles/components/Navbar.css";
import { GlobalContext } from "../context/global/GlobalContext";

const { AUTHENTICATION } = TYPES;

export const Navbar = () => {
    const {userState, userDispatch} = useContext(GlobalContext);
    const { mode, toggleTheme } = useThemeMode();
    const [isAuthenticated, setIsAuthenticated] = useState(!!userState.user);
    const [active, setActive] = useState(false);
    const navigate = useNavigate();

    // Actualizar estado de autenticación cuando cambia el usuario
    useEffect(() => {
        setIsAuthenticated(!!userState.user);
    }, [userState.user]);

    const handleLogout = async () => {
        try {
            // Update global context first
            const action = {
                type: AUTHENTICATION.LOGOUT
            };
            userDispatch(action);

            // Clear localStorage and redirect
            AuthService.logout();
        } catch (error) {
            console.error('[NAVBAR] Logout error:', error);
            // Forzar logout incluso si hay error
            AuthService.logout();
        }
    };

    // Construir nombre completo del usuario
    const getUserName = () => {
        const user = userState.user;
        if (!user) return 'Usuario';
        
        if (user.firstName && user.lastName) {
            return `${user.firstName} ${user.lastName}`;
        }
        if (user.firstName) return user.firstName;
        if (user.name) return user.name;
        if (user.email) return user.email.split('@')[0];
        return 'Usuario';
    };

    return (
        <nav>
            <div className="navbar">
                <img 
                    id="navbar__logo"
                    className="icon-navbar" 
                    src={mode === 'dark' ? logo_icon_white : logo_icon} 
                    alt="logo" 
                    onClick={ () => navigate('/')}/>
                
                <IconButton 
                    onClick={toggleTheme}
                    sx={{ 
                        color: mode === 'dark' ? '#fff' : '#000',
                        marginLeft: 'auto',
                        marginRight: isAuthenticated ? '0' : 'auto'
                    }}
                    aria-label="toggle theme"
                >
                    {mode === 'dark' ? <MdLightMode size={24} /> : <MdDarkMode size={24} />}
                </IconButton>

                {
                isAuthenticated &&
                <>  
                    <HiMenuAlt3 
                        id="navbar__menu-icon"
                        className='icon-navbar' 
                        onClick={() => setActive(!active)}/>

                    <div className={`navbar__navigation ${active?'active':''}`}>
                        <div className="navbar__navigation--links">
                            <Link className="navbar__navigation--link" to='/'>Inicio</Link>
                            <Link className="navbar__navigation--link" to='/account'>Mi Cuenta</Link>
                            <Link className="navbar__navigation--link" to='/plans'>Planes</Link>
                            {userState.user?.isAdmin && (
                                <Link className="navbar__navigation--link" to='/admin'>Panel Admin</Link>
                            )}
                            <button 
                                className="navbar__navigation--link" 
                                onClick={handleLogout}
                                style={{
                                    background: 'none',
                                    border: 'none',
                                    cursor: 'pointer',
                                    padding: 0,
                                    color: 'inherit',
                                    font: 'inherit',
                                    textAlign: 'left'
                                }}
                            >
                                Cerrar sesión
                            </button>
                        </div>

                        <div className="navbar__navigation--avatar">
                            <img 
                                id="navbar__avatar-icon"
                                className="icon-navbar" 
                                src={user_icon} 
                                alt="avatar"/>
                            <p id="navbar__avatar-text">{getUserName()}</p>
                        </div>
                    </div>                    
                </>
                }
            </div>
        </nav>
    );
};